import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip/Tooltip';

interface ProjectMetadataProps {
	project: string;
}

const containerStyles = xcss({
	display: 'inline-block',
	maxWidth: '215px', // from Figma design
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

export const ProjectMetadata = ({ project }: ProjectMetadataProps): React.JSX.Element => {
	return (
		<Tooltip content={project}>
			{(tooltipProps) => (
				<Box xcss={containerStyles} testId="project-metadata" {...tooltipProps}>
					{project}
				</Box>
			)}
		</Tooltip>
	);
};
